webpackJsonp([44],{

/***/ "YCCM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lazy_modules_1 = __webpack_require__("bUzP");
var BgVideoSlider = (function () {
    BgVideoSlider.$inject = ["$element", "$q"];
    function BgVideoSlider($element, $q) {
        var _this = this;
        this.$element = $element;
        this.$q = $q;
        this.start = false;
        this.showNext = false;
        this.flicktyPromise = $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); });
        setTimeout(function () { return _this.showNext = true; }, 3000);
    }
    BgVideoSlider.prototype.$postLink = function () {
        this.initFlickty('.vm-product-item', true, false);
    };
    BgVideoSlider.prototype.showVideo = function (index) {
        return this.start && (index === 0 || this.showNext);
    };
    BgVideoSlider.prototype.handlerVideoLoaded = function () {
        this.showNext = true;
    };
    BgVideoSlider.prototype.initFlickty = function (cellSelector, prevNextButtons, pageDots) {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            new Flickity(_this.$element[0].firstChild, {
                cellSelector: cellSelector,
                prevNextButtons: prevNextButtons,
                pageDots: pageDots,
                wrapAround: true,
                resize: false,
                cellAlign: 'center',
                adaptiveHeight: true,
                setGallerySize: false
            });
            _this.start = true;
        });
    };
    return BgVideoSlider;
}());
angular.module('animatronApp.bgVideoSlider', []).component('bgVideoSlider', {
    bindings: {
        slides: '<'
    },
    controller: BgVideoSlider,
    templateUrl: __webpack_require__("lc6T")
});


/***/ }),

/***/ "lc6T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/bg-video-slider_e693068d098e3d084b7d3439fb0ff096.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/44-82c0e6a2dceb23823569.min.js